<style scoped>

.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  pointer-events:none;
  opacity: 0.9;
}
.quiz-panel {
  pointer-events:all;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
</style>

<template>
  <mu-paper class="overlay" v-if="isQuizShow">
    <quiz-panel
      class="quiz-panel"
      :mediaId="mediaId"
      :timestamp="modelTimestamp"
      :currentTime="currentTime"
      :embedMode="true"
      @onSubmit="onSubmit"
      @onClose="onClose"
      />
  </mu-paper>
</template>

<script>

// Event Bus
import {bus} from '@/main.js';
// Components
import QuizPanel from '@/components/Quiz/QuizPanel.vue'

// Library
import axios from "axios";

export default {
  name: 'QuestionOverlay',
  components: {
    QuizPanel
  },
  props: {
    mediaId: {
      type: String,
      required: true
    },
    currentTime: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      questions: [],
      timestampList: [],
      modelTimestamp: 0,
      flagFetchedQuestions: false,
      
      flagQuizShow: false,
    }
  },
  computed: {
    // String
    currentTimeRound() {
      return Math.floor(this.currentTime);
    },

    // Flag
    isQuizShow() {
      return this.flagQuizShow;
    },
  },
  watch: {
    mediaId() {
      this.fetchQuestions();
    },
    currentTime(newValue) {
      if(this.flagFetchedQuestions && this.timestampList.length >= 1) {
        this.timestampList.sort((a, b) => {
          return a - b;
        });
      }
      if(newValue >= this.timestampList[0]) {
        this.modelTimestamp = this.timestampList[0];
        this.timestampList.splice(0, 1);
        bus.$emit('pause');
        this.flagQuizShow = true;
      }
    },
  },
  mounted() {
    this.fetchQuestions();
  },
  methods: {
    // Fetch
    fetchQuestions() {
      axios.get(this.$store.getters.urlApi + "question/media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.questions = response.data.data.questions;
        this.flagFetchedQuestions = true;
        var i;
        for (i = 0; i < this.questions.length; i++) {
          if(this.questions[i].hasOwnProperty('timestamp')) {
            if(!this.timestampList.includes(this.questions[i].timestamp) && this.questions[i].timestamp !== -1) {
              this.timestampList.push(this.questions[i].timestamp);
            }
          }
        }
        if(this.flagFetchedQuestions && this.timestampList.length >= 1) {
          this.timestampList.sort((a, b) => {
            return a - b;
          });
        }
        if(this.currentTime >= this.timestampList[0]) {
          this.modelTimestamp = this.timestampList[0];
          this.timestampList.splice(0, 1);
          this.$emit('playerPause');
          this.flagQuizShow = true;
        }
      });
    },

    // Event
    onSubmit() {
      
    },
    
    onClose() {
      this.flagQuizShow = false;
      bus.$emit('play');
    }
  }
}
</script>
